import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { guaranteeSteps } from "../data/content";
export function Guarantee() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-157" data-mp="223y639n82bl6">
      <div className="mx-auto max-w-2xl text-center" data-id="element-158" data-mp="221byxb48ty3h">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-plum-800 text-white" data-id="element-159" data-mp="1x421p9am4i53">
          <ShieldCheckIcon className="h-8 w-8 text-gold" aria-hidden data-id="element-160" data-mp="19co7sywtcei0" />
          <span className="mt-1 font-display text-2xl font-black leading-none" data-id="element-161" data-mp="14gz3yjdrgbfw">7 DAYS</span>
        </div>
        <h2 className="mt-6 font-display text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-162" data-mp="1j5c13jol40bz">
          7-Day <em className="text-plum-600" data-id="element-163" data-mp="1eciyb1cof22j">Money-Back</em> Guarantee
        </h2>
        <p className="mt-4 text-[17px] text-ink/75" data-id="element-164" data-mp="qmyeyhcm22sq">Try IMPLANT DECISION SYSTEM™ for 7 days.</p>

        <ul className="mx-auto mt-6 max-w-sm space-y-3 text-left" data-id="element-165" data-mp="lo4wsbmdpnm8">
          {guaranteeSteps.map(s => <li key={s} className="flex items-start gap-3 text-[16px] text-ink/85" data-id="element-166" data-mp="oyqalznmtfex">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-go" strokeWidth={3} aria-hidden data-id="element-167" data-mp="txkvr892ng27" />
              {s}
            </li>)}
        </ul>

        <p className="mt-6 text-[16px] leading-relaxed text-ink/70" data-id="element-168" data-mp="12qwsprachwh0">
          If within the first 7 days you decide that IMPLANT DECISION SYSTEM™ isn't valuable to your practice, you can
          request a refund according to the terms of the guarantee.
        </p>

        <div className="mt-10" data-id="element-169" data-mp="b00hsw7ui1wd">
          <CtaButton label="Try it risk-free for 7 days" data-id="element-170" data-mp="f1bygc8qrcsf" />
        </div>
      </div>
    </section>;
}